import { useFormik } from 'formik';
import { Fragment, useState } from 'react';
import { Grid } from "@mui/material";
import InputTextBox from '../../../../widgets/InputTextBox';
import NepaliInputTextBox from '../../../../widgets/NepaliInputTextBox';
import { SaveBtn } from '../../../../widgets/AppBtn';
import ComponentHeading from '../../../../widgets/ComponentHeading';
import { IoMdAddCircle } from "react-icons/io";
import { postDataToTheServer } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { ToastError, ToastSuccess } from '../../../../widgets/ToastMessage';
import Select from 'react-select';

const EnthinicityMappingCreateView = ({ FetchData }) => {
  const [customValues, setCustomValues] = useState({
    caste_name_nep: "",
  });
 const OldStudentOptions = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
];
  const handleNepaliInputChange = (fieldName, value) => {
    handleChange(fieldName)(value)
    setCustomValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };
  const initialValues = {
    caste_name: "",
    caste_name_nep: "",
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: async (values, action) => {
        const formData = new FormData();
        formData.append("caste_name", values.caste_name);
        formData.append("caste_name_nep", customValues.caste_name_nep);
        formData.append("ethnicity", customValues.ethnicity);

        try {
          await postDataToTheServer(AppURL.AcademicsURL + "academics-ethnicity-mapping-create-list-view/", formData).then((res) => {
            if (res?.status === 201) {
              ToastSuccess(res?.message);
              action.resetForm();
              setCustomValues({ caste_name_nep: "" });
              FetchData();
            } else {
              ToastError("Something Errors");
            }
          });
        } catch (error) {
          console.log(error);
        }
      },
    });
    console.log(Array.isArray(OldStudentOptions))

  return (
    <form onSubmit={handleSubmit} className="px-4 py-4 dark:bg-slate800 bg-white rounded-md ">
      <ComponentHeading label={"Add Enthinicity Mapping"} icon={IoMdAddCircle} />
      <Grid container spacing={1.5}>
        <Grid item xl={6} md={6} lg={6} xs={12} sm={12}>
          <InputTextBox
            name="caste_name"
            type="text"
            label={"Caste Name"}
            value={values.caste_name}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched.caste_name}
            errors={errors.caste_name}
            required={true}
          />
        </Grid>
        <Grid item xl={6} md={6} lg={6} xs={12} sm={12}>
          <NepaliInputTextBox
            name="caste_name_nep"
            label={"Caste Name (Nepali)"}
            value={customValues.caste_name_nep}
            onCustomValueChange={handleNepaliInputChange}
            handleBlur={handleBlur}
            touched={touched.caste_name_nep}
            errors={errors.caste_name_nep}
            required={true}
          />
        </Grid>
        <Grid item xl={6} md={6} lg={6} xs={12} sm={12}>
          <Fragment>
            <label className='font-public-sans text-xs font-semibold mb-2 text-gray-700'>
              Ethnicity
            </label>
            <Select
              defaultValue={[]}
              isMulti
              name="colors"
              // options={colourOptions}
              placeholder=""
              className="basic-multi-select font-public-sans"
              classNamePrefix="select font-public-sans text-[12px]"
            />
          </Fragment>
        </Grid>
      </Grid>
      <div className="flex justify-end mt-3 gap-2">
        <SaveBtn type="submit" />
      </div>
    </form>
  )
}

export default EnthinicityMappingCreateView